import { Flex } from '@shared/components';

import { EventDateCard } from '../event-date-card';
import { ExamEventCard, type ExamEventCardProps } from '../exam-event-card';

export interface ExamEventDailyScheduleProps {
  date: Date;
  examEvents: (ExamEventCardProps & { id: string; examCenterCode: string })[];
}

export default function ExamEventDailySchedule(props: Readonly<ExamEventDailyScheduleProps>) {
  const { date, examEvents } = props;

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(2) })}>
      <EventDateCard date={date} />
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2), flex: 1 })}>
        {examEvents.map((examEvent) => {
          return (
            <ExamEventCard
              {...examEvent}
              key={examEvent.id}
              sx={{
                cursor: 'pointer',
              }}
            />
          );
        })}
      </Flex>
    </Flex>
  );
}
